export const FirebaseApiKey = process.env.REACT_APP_FIREBASE_API_KEY;
export const machineState = [
   {
     value: "1",
     text: "Show All",
   },
   {
     value: "2",
     text: "Assigned",
   },
   {
     value: "3",
     text: "Unassigned",
   },
   {
     value: "4",
     text: "Started",
   },
   {
     value: "5",
     text: "Shutdown",
   },
   {
     value: "6",
    text: "Archived",
  },
  {
    value: "7",
     text: "Destroyed",
   },
 ];
